<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="title_hf"><span class="right_1" epub:type="pagebreak" id="page_xvii" title="xvii"><span class="smallcaps">THE</span> EXPULSION <span class="smallcaps">OF</span> JEWS<br/><span class="smallcaps">FROM</span> COMMUNIST POLAND<span class="right_1" epub:type="pagebreak" id="page_xviii" title="xviii"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle1.vue?f7ab07f8